import React from "react";
import "./LandingSection.css";

import { motion } from "framer-motion";
import Button from "../../../components/Button/Button";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledH1Heading from "../../../common/components/styledH1Heading/StyledH1Heading";
import StyledH2Heading from "../../../common/components/styledH2Heading/StyledH2Heading";

const styles = {
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundImage: "url('/assets/hero-bg.png')",
};

const LandingSection = () => {
  return (
    <motion.div
      id="home"
      style={styles}
      className="flex justify-center w-full 2xl:h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
      <div className="flex flex-col lg:flex-row justify-between items-center lg:items-end 2xl:items-center gap-10 w-11/12 sm:w-[85%] pt-[9rem] pb-14 2xl:h-[100vh]">
        {/* Main Content */}
        <motion.div
          className="flex flex-col gap-5 border-4 border-orange rounded-[20px] w-full xl:w-[52%] p-5 sm:p-10 relative"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5, ease: "easeInOut" }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.6, ease: "easeInOut" }}
          >
            <StyledH2Heading
              font="text-white"
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
            >
              <span className="!font-druk-wide-bold pr-1">$</span>JEPE
            </StyledH2Heading>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.7, ease: "easeInOut" }}
          >
            <StyledH1Heading
              font="textGradient strokeText"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.8, ease: "easeInOut" }}
            >
              No Mercy, only victory
            </StyledH1Heading>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.8, ease: "easeInOut" }}
          >
            <StyledMdText
              font="text-white"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.9, ease: "easeInOut" }}
            >
              Welcome to the realm of Jaba The Pepe, where ruthlessness and meme
              magic collide. Join the revolution and conquer the crypto world
              with the unstoppable force of Jaba The Pepe. Are you ready to
              dominate?
            </StyledMdText>
          </motion.div>

          {/* Buy now Button */}
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="w-fit"
            transition={{ duration: 0.3 }}
          >
            <Button variant="gradientButton" font="py-4 px-9 text-white">
              buy now
            </Button>
          </motion.div>

          {/* Animated Logo */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1, ease: "easeInOut" }}
            className="w-1/3 sm:w-fit absolute -bottom-6 right-5 sm:right-10 bg-transparent backdrop-blur-lg animatedLogo"
          >
            <motion.img
              src="/assets/border-logo.svg"
              alt="Jaba The Pepe"
              className="mx-auto"
            />
          </motion.div>
        </motion.div>

        {/* Frog Image */}
        <motion.div
          className="flex justify-center items-center w-11/12 lg:w-fit"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: "easeInOut" }}
        >
          <motion.img
            src="/assets/hero-frog.png"
            alt="Frog"
            className="w-fit"
            animate={{
              scale: [1, 1.03, 1],
            }}
            transition={{
              duration: 2,
              delay: 1.5,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "linear",
            }}
          />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default LandingSection;
